export enum KeyframeHighlightType {
  KEYFRAME_SNAP_REF,
}
